import { LocaleService } from '@farris/ui-locale';
import { Pipe, PipeTransform, Injector, Optional } from '@angular/core';
import { ColumnFormatService } from '@farris/ui-common/column';

@Pipe({ name: 'formatPrimeNgTreeTableCellData', pure: false })
export class FormatPrimeNgTreeTableCellData implements PipeTransform {
  private localeService: LocaleService;
  constructor(private cfs: ColumnFormatService, @Optional() private injector?: Injector) {
    if (this.injector) {
      this.localeService = this.injector.get(LocaleService);
    }
  }

  transform(col: any, rowData: any): any {
    let value = '';
    if (rowData && col && col.field) {
      value = this.getValue(col.field, rowData);
      let formatterFn = col.formatter;
      if (!formatterFn) {
        if (col.isMultilingualField) {
          return this.getMultiLanguageValue(value);
        } else {
          return value;
        }
      } else {
        return this.cfs.format(value, rowData, formatterFn);
      }
    }
    return '';
  }

  // è·åå¤è¯­æ°æ®
  private getMultiLanguageValue(valObj) {
    if (valObj && typeof valObj === 'object' && Object.keys(valObj).length > 0) {
      const localeId = this.localeService && this.localeService.localeId || 'zh-CHS';
      const value = valObj[localeId];
      return value === undefined ? '' : value;
    } else {
      return '';
    }
  }
  private getValue(path: string, target: any) {
    if (!target) {
      return '';
    }
    var resultVal = '';
    if (path.indexOf('.') === -1) {
      resultVal = target[path];
    }
    else {
      resultVal = path.split('.').reduce(((obj, key) => {
        return obj && obj[key] || null;
      }), target);
    }
    return resultVal;
  };
  /**
   * æ¯å¦ä¸ºå¸®å©å
   * @param col col
   */
  private isHelpColumn(col: any) {
    return col && col.editor && col.editor.options && col.editor.options.type === 'EditorTypes.LOOKUP' || false;
  }
  private getHelpColumnValue(col: any, data: any) {
    const textField = this.getHelpControlTextField(col);
    const mapFields = this.getHelpControlMapFields(col);
    if (textField && mapFields && Object.keys(mapFields).length > 0) {
      const path = mapFields[textField];
      return this.getValue(path, data);
    }
    return '';
  }
  private getHelpControlTextField(col: any) {
    return col && col.editor && col.editor.options && col.editor.options.textField || '';
  }
  private getHelpControlMapFields(col: any) {
    return col && col.editor && col.editor.options && col.editor.options.mapFields || {};
  }
}
